import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/main-layout/MainLayout";
import AdminDashboard from "../pages/admin-dashboard/AdminDashboard";
import EditAdmin from "../pages/view-edit-admin/EditAdmin";
import AddAdmin from "../pages/add-admin/AddAdmin";
import { routePaths } from "./RoutePath";
import EditMilestone from "../pages/view-edit-milestone/EditMilestone";
import AdminProtectedRoute from "./AdminProtectedRoute";
import CreateMilestone from "../pages/create-milestone/CreateMilestone";
import OptInOptOut from "../pages/opt-in-opt-out/components/OptInOptOut";
import LoginPage from "../features/login-page/LoginPage";
import PatientProtectedRoute from "./PatientProtectedRoute";
import ClaimRedemptionContainer from "../pages/admin-claim-redemption/ClaimRedemptionContainer";
import PageNotFound from "../pages/page-not-found/PageNotFound";
import EditPatientDetails from "../pages/edit-patient-details/EditPatientDetails";
import PatientProfileNew from "../features/patient-profile/v2/PatientProfileNew";
import PatientMainLayout from "../layouts/main-layout/PatientMainLayout";
import PatientDashboardWrapper from "../pages/patient-dashboard/PatientDashboardWrapper";
import MyUltrasound from "../pages/V2Pages/Ultrasounds/MyUltrasound";
import MyCarePlanPage from "../pages/V2Pages/my-care-plan-page/MyCarePlanPage";
import MyRewardsPage from "../pages/V2Pages/my-rewards-page/MyRewardsPage";
import ViewFaq from "../features/view-faq/ViewFaq";
import MyLearnings from "../pages/V2Pages/my-learnings/MyLearnings";

const adminRoutes = [
  {
    path: routePaths.admin.dashboard,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <AdminDashboard />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.editUser,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <EditAdmin />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.addUser,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <AddAdmin />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.editMilestone,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <EditMilestone />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.createMilestone,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <CreateMilestone />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.editPatientDetails,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <EditPatientDetails />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
  {
    path: routePaths.admin.claimRedemption,
    element: (
      <AdminProtectedRoute>
        <MainLayout>
          <ClaimRedemptionContainer />
        </MainLayout>
      </AdminProtectedRoute>
    ),
  },
];

const patientRoutes = [
  {
    path: routePaths.patient.dashboard,
    element: (
      <PatientProtectedRoute>
        <PatientDashboardWrapper />
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.profile,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <PatientProfileNew />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.optInOut,
    element: (
      <PatientProtectedRoute>
        <OptInOptOut />
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.rewardActivity,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <MyRewardsPage />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.ultrasound,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <MyUltrasound />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.learning,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <MyLearnings />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.carePlan,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <MyCarePlanPage />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
  {
    path: routePaths.patient.faq,
    element: (
      <PatientProtectedRoute>
        <PatientMainLayout>
          <ViewFaq />
        </PatientMainLayout>
      </PatientProtectedRoute>
    ),
  },
];

export const appRouteConfigs = createBrowserRouter([
  {
    path: routePaths.home,
    element: <LoginPage />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  ...adminRoutes,
  ...patientRoutes,
]);
